import { createContext, useContext } from "react";

export const LANGUAGES = [
  { id: "ar", name: "العربية" },
  { id: "cs", name: "Čeština" },
  { id: "da", name: "Dansk" },
  { id: "de", name: "Deutsch" },
  { id: "el", name: "Ελληνικά" },
  { id: "en", name: "English" },
  { id: "es", name: "Español" },
  { id: "fa", name: "فارسی" },
  { id: "fi", name: "Suomi" },
  { id: "fr", name: "Français" },
  { id: "he", name: "עברית" },
  { id: "hi", name: "हिन्दी" },
  { id: "hr", name: "Hrvatski" },
  { id: "hu", name: "Magyar" },
  { id: "id", name: "Bahasa Indonesia" },
  { id: "it", name: "Italiano" },
  { id: "ja", name: "日本語" },
  { id: "ko", name: "한국어" },
  { id: "ms", name: "Bahasa Melayu" },
  { id: "nb", name: "Norsk" },
  { id: "nl", name: "Nederlands" },
  { id: "pa", name: "ਪੰਜਾਬੀ" },
  { id: "pl", name: "Polski" },
  { id: "pt_BR", name: "Português do Brasil" },
  { id: "ro", name: "Româna" },
  { id: "ru", name: "Русский" },
  { id: "sk", name: "Slovensky" },
  { id: "sv", name: "Svenska" },
  { id: "th", name: "ไทย" },
  { id: "tr", name: "Türkçe" },
  { id: "uk", name: "Українська" },
  { id: "vi", name: "Tiếng Việt" },
  { id: "zh_Hans", name: "简体中文" },
  { id: "zh_Hant", name: "繁體中文" },
];

export const LanguageContext = createContext<{
  locale?: string;
  selectLanguage?: (locale: string) => void;
}>({
  locale: undefined,
  selectLanguage: undefined,
});

export function useLocaleUpdate() {
  return useContext(LanguageContext).selectLanguage;
}

export function useLocalizeLocale() {
  return useContext(LanguageContext).locale;
}
